<template>
  <div class="public-preview">
    <component :is="params.type" :data="params.data"></component>
  </div>
</template>

<script>
import huaaoPreviewPicture from './components/huaao-preview-picture.vue'
import tbhPreviewPictureSwipper from './components/tbh-preview-pictuere-swipper.vue'
import shrilePdfPreviewDownload from './components/shrile-pdf-preview-download.vue'
import huaaoStandardSolutionCheckPicture from './components/huaao-standardSolution-check-picture.vue'

export default {
  name: 'public-preview',
  components: {
    huaaoPreviewPicture,
    tbhPreviewPictureSwipper,
    shrilePdfPreviewDownload,
    huaaoStandardSolutionCheckPicture
  },
  data () {
    return {
      params: {}
    }
  },
  created () {
    let params = this.$route.query
    params.data = typeof params.data === 'string' ? JSON.parse(params.data) : params.data
    this.params = params
    document.title = params.title || '文件预览'
  }
}
</script>

<style lang="scss">
  .public-preview {
    height: 100%;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/globalComponent/publicPreview/public-preview.vue